import { useState } from "react";
import { NavLink, Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { ACADEMY, NAV_LINKS } from "../lib/academy-data";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  return (
    <header
      className="sticky top-0 z-50 bg-[#0A0A0A]/85 backdrop-blur-xl border-b border-white/10"
      data-testid="navbar"
    >
      <div className="container mx-auto px-6 md:px-10">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link
            to="/"
            className="flex items-center gap-3"
            data-testid="navbar-logo"
            onClick={() => setOpen(false)}
          >
            <img
              src={ACADEMY.logo}
              alt="הפועל מטה יהודה"
              className="h-12 w-12 object-contain"
            />
            <div className="hidden sm:flex flex-col leading-tight">
              <span className="font-heading font-black text-base text-white uppercase tracking-wider">
                האקדמיה
              </span>
              <span className="font-body text-xs text-neutral-400">
                הפועל מטה יהודה
              </span>
            </div>
          </Link>

          {/* Desktop nav */}
          <nav className="hidden lg:flex items-center gap-8">
            {NAV_LINKS.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                end={link.to === "/"}
                data-testid={`nav-link-${link.to.replace("/", "") || "home"}`}
                className={({ isActive }) =>
                  `nav-link font-heading font-bold text-sm tracking-wide uppercase transition-colors ${
                    isActive ? "text-[#DC2626] active" : "text-white hover:text-[#DC2626]"
                  }`
                }
              >
                {link.label}
              </NavLink>
            ))}
          </nav>

          {/* CTA */}
          <a
            href="/contact"
            className="hidden lg:inline-flex items-center justify-center bg-[#DC2626] hover:bg-[#B91C1C] text-white font-heading font-bold text-sm uppercase tracking-wider px-5 py-2.5 rounded-sm transition-all duration-300 shadow-[0_0_20px_rgba(220,38,38,0.35)] hover:shadow-[0_0_30px_rgba(220,38,38,0.6)] hover:-translate-y-0.5"
            data-testid="navbar-contact-cta"
          >
            צור קשר
          </a>

          {/* Mobile menu button */}
          <button
            onClick={() => setOpen(!open)}
            className="lg:hidden text-white p-2"
            data-testid="mobile-menu-toggle"
            aria-label="תפריט"
          >
            {open ? <X size={28} strokeWidth={2.5} /> : <Menu size={28} strokeWidth={2.5} />}
          </button>
        </div>

        {/* Mobile menu */}
        {open && (
          <div className="lg:hidden pb-6 pt-2 border-t border-white/10" data-testid="mobile-menu">
            <nav className="flex flex-col gap-1">
              {NAV_LINKS.map((link) => (
                <NavLink
                  key={link.to}
                  to={link.to}
                  end={link.to === "/"}
                  onClick={() => setOpen(false)}
                  data-testid={`mobile-nav-link-${link.to.replace("/", "") || "home"}`}
                  className={({ isActive }) =>
                    `font-heading font-bold text-base py-3 px-2 border-b border-white/5 transition-colors ${
                      isActive ? "text-[#DC2626]" : "text-white hover:text-[#DC2626]"
                    }`
                  }
                >
                  {link.label}
                </NavLink>
              ))}
              <a
                href="/contact"
                className="mt-4 text-center bg-[#DC2626] hover:bg-[#B91C1C] text-white font-heading font-bold text-sm uppercase tracking-wider px-5 py-3 rounded-sm transition-all duration-300"
                data-testid="mobile-navbar-contact-cta"
                onClick={() => setOpen(false)}
              >
                צור קשר
              </a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}
